import React from "react";

const UserIcon = ({
  color = "#2B363B",
  size = 20,
  width,
  height,
  ...props
}) => {
  const w = width || size;
  const h = height || size;
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Icono usuario"
      {...props}
    >
      <g clipPath="url(#clip0_user_icon)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3332 7.49984C13.3332 8.38389 12.982 9.23174 12.3569 9.85686C11.7317 10.482 10.8839 10.8332 9.99984 10.8332C9.11578 10.8332 8.26794 10.482 7.64281 9.85686C7.01769 9.23174 6.6665 8.38389 6.6665 7.49984C6.6665 6.61578 7.01769 5.76794 7.64281 5.14281C8.26794 4.51769 9.11578 4.1665 9.99984 4.1665C10.8839 4.1665 11.7317 4.51769 12.3569 5.14281C12.982 5.76794 13.3332 6.61578 13.3332 7.49984ZM11.6665 7.49984C11.6665 7.94186 11.4909 8.36579 11.1783 8.67835C10.8658 8.99091 10.4419 9.1665 9.99984 9.1665C9.55781 9.1665 9.13389 8.99091 8.82133 8.67835C8.50877 8.36579 8.33317 7.94186 8.33317 7.49984C8.33317 7.05781 8.50877 6.63389 8.82133 6.32133C9.13389 6.00877 9.55781 5.83317 9.99984 5.83317C10.4419 5.83317 10.8658 6.00877 11.1783 6.32133C11.4909 6.63389 11.6665 7.05781 11.6665 7.49984Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.99992 0.833252C4.93742 0.833252 0.833252 4.93742 0.833252 9.99992C0.833252 15.0624 4.93742 19.1666 9.99992 19.1666C15.0624 19.1666 19.1666 15.0624 19.1666 9.99992C19.1666 4.93742 15.0624 0.833252 9.99992 0.833252ZM2.49992 9.99992C2.49992 11.7416 3.09409 13.3449 4.08992 14.6183C4.78945 13.7 5.69171 12.9559 6.72628 12.4439C7.76086 11.9319 8.89975 11.6658 10.0541 11.6666C11.1936 11.6653 12.3183 11.9242 13.3425 12.4236C14.3667 12.923 15.2634 13.6497 15.9641 14.5483C16.6861 13.6013 17.1723 12.4959 17.3823 11.3237C17.5924 10.1516 17.5203 8.9462 17.172 7.80741C16.8237 6.66861 16.2093 5.62913 15.3795 4.77495C14.5497 3.92077 13.5285 3.27647 12.4002 2.89534C11.272 2.51422 10.0693 2.40723 8.89147 2.58323C7.71369 2.75923 6.59474 3.21316 5.62723 3.90746C4.65971 4.60177 3.87143 5.51648 3.32761 6.57592C2.78379 7.63535 2.50007 8.80906 2.49992 9.99992ZM9.99992 17.4999C8.27818 17.5027 6.60837 16.9104 5.27325 15.8233C5.81059 15.0538 6.52591 14.4255 7.35831 13.992C8.19072 13.5584 9.11555 13.3324 10.0541 13.3333C10.9809 13.3324 11.8945 13.5528 12.7191 13.976C13.5436 14.3992 14.2553 15.0131 14.7949 15.7666C13.4495 16.8891 11.7521 17.5027 9.99992 17.4999Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_user_icon">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UserIcon;
